import {useQuery} from "@tanstack/react-query"
import axios from "axios"
import {FieldListSearchResult} from "../types/FieldList";

interface UseFieldListUpdateQueryProps {
    fieldListId: number
}

export default function useFieldListUpdateQuery({
  fieldListId,
}: UseFieldListUpdateQueryProps) {
    return useQuery({
        queryKey: ['updateFieldList', fieldListId],
        queryFn: async () => {
            if (fieldListId === 0) return null;
            const GET_FIELD_LIST_UPDATE_ENDPOINT = `/admin/action/automation/admin/getFieldListById/${fieldListId}`;
            const { data } = await axios.get(GET_FIELD_LIST_UPDATE_ENDPOINT)
            const fieldList = data.FIELD_LIST;
            return fieldList as FieldListSearchResult;
        },
    })
}